/**
 * @generated SignedSource<<023c43b20d98a2a90391b45cc41a7da5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnnouncementMessageActions_chat_messageFragment$data = {
  readonly canDelete: {
    readonly value: boolean;
  };
  readonly canUpdate: {
    readonly value: boolean;
  };
  readonly deletedAt: ISO8601DateTimeString | null;
  readonly id: string;
  readonly reactions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly deletedAt: ISO8601DateTimeString | null;
        readonly id: string;
      };
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementReactionButton_chat_messageFragment">;
  readonly " $fragmentType": "AnnouncementMessageActions_chat_messageFragment";
};
export type AnnouncementMessageActions_chat_messageFragment$key = {
  readonly " $data"?: AnnouncementMessageActions_chat_messageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementMessageActions_chat_messageFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnnouncementMessageActions_chat_messageFragment",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnnouncementReactionButton_chat_messageFragment"
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canUpdate",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canDelete",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReactionsConnection",
      "kind": "LinkedField",
      "name": "reactions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReactionsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Message",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Message",
  "abstractKey": null
};
})();

(node as any).hash = "f1608dbc66037645139371dc146d7f79";

export default node;
